module.exports = __webpack_public_path__ + "img/Logistiker3.b99f48e3.jpg";